const customValidatorDirective = /* @ngInject */ () => ({
	restrict: 'A',
	require:  'ngModel',
	/**
	 * @param {any} scope
	 * @param {import('angular').IRootElementService} ele
	 * @param {import('angular').IAttributes} attributes
	 * @param {any} ngModelCtrl
	 */
	link(scope, ele, attributes, ngModelCtrl) {
		const { component } = scope.$parent;

		if (scope.options && scope.options.building || !component) {
			return;
		}
		if (
			!component.validate
			|| !component.validate.custom
		) {
			return;
		}

		/**
		 * @param {any} item
		 * @param {string | string[]} path
		 * @param {any} [defaultItem]
		 * @returns {any}
		 */
		const getItem = (item, path, defaultItem = null) => {
			if (!item) {
				return defaultItem || undefined;
			}
			if (!path) {
				return item;
			}

			// If the path is a string, turn it into an array.
			if (typeof path === 'string') {
				// eslint-disable-next-line no-param-reassign
				path = path.split('.');
			}
			// If the path is an array, take the first element, and recurse its path
			if (Array.isArray(path)) {
				const current = path.shift();
				if (current && current in item) {
					// If there are no more path items, stop here.
					if (path.length === 0) {
						return item[current];
					}

					return getItem(item[current], path);
				}

				return undefined;
			}

			return undefined;
		};

		ngModelCtrl.$validators.custom = (/** @type {any} */ modelValue, /** @type {any} */ viewValue) => {
			let valid = true;
			/* eslint-disable no-unused-vars */
			const input = modelValue || viewValue;

			if (!scope?.submission) {
				return true;
			}

			// FOR-255 - Enable row data and form data to be visible in the validator.
			const { data } = scope.submission;

			/* eslint-enable no-unused-vars */

			let { custom } = component.validate;
			custom = custom.replaceAll(
				/({{\s*(.*\S)\s*}})/g,
				(
					/** @type {any} */ match,
					/** @type {any} */ $1,
					/** @type {string | string[]} */ $2,
				) => getItem(data, $2),
			);

			try {
				/* jshint evil: true */
				// eslint-disable-next-line no-eval
				eval(custom);
			}
			catch (/** @type {any} */ error) {
				valid = error.message;
			}

			if (valid !== true) {
				component.customError = valid;
				return false;
			}
			return true;
		};
	},
});

export default customValidatorDirective;
